import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { KitImagem } from '../models/kit-imagem';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class KitImagemService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarKitsImagens() {
    return this.http.get<KitImagem[]>(globals.apiUrl + '/api/KitImagem/Lista');
  }

  consultarKitImagemsComPaginacao(painel: string, marcaInversor: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (painel.trim() !== '') {
      parametros = parametros.set('painel', painel);
    }

    if (marcaInversor.trim() !== '') {
      parametros = parametros.set('marcaInversor', marcaInversor);
    }

    return this.http.get<any>(globals.apiUrl + '/api/KitImagem/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdKitImagem(id) {
    return this.http.get<any>(globals.apiUrl + '/api/KitImagem/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(kitImagem) {
    return this.http.post(globals.apiUrl + '/api/KitImagem/Salvar', kitImagem);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/KitImagem/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
